// Commercial model — pricing & feature gating. Change pricing here without
// touching product logic.
export const PLANS = {
  score: {
    key: "score",
    name: "Growth Score",
    price: 49,
    tagline: "Measure & understand your brand performance.",
    features: [
      "Growth Score & breakdown",
      "Competitor benchmarking",
      "Social ranking",
      "Brand health & consistency",
      "Monthly Growth Report",
      "NicheCom activity & unused content",
      "Content utilisation",
    ],
  },
  schedule: {
    key: "schedule",
    name: "Growth Schedule",
    price: 299,
    tagline: "Turn content into a published weekly plan.",
    features: [
      "Everything in Score",
      "Content creation & captions",
      "Social Week planner",
      "NicheCom asset integration",
      "Approval workflow",
      "Local & seasonal content",
      "Publishing workflow",
    ],
  },
  managed: {
    key: "managed",
    name: "Growth Managed",
    price: 999,
    tagline: "An expert marketing team inside the software.",
    features: [
      "Everything in Schedule",
      "Managed publishing",
      "Manual Instagram Stories, polls & link stickers",
      "Reels & Highlights",
      "Ongoing optimisation",
      "Priority support",
      "Brand oversight",
    ],
  },
};

export const TIER_ORDER = ["score", "schedule", "managed"];

// Which capabilities each tier unlocks.
const CAPS = {
  score: ["overview", "growth-score", "competitors", "nichecom", "insights", "reports"],
  schedule: ["overview", "growth-score", "competitors", "nichecom", "insights", "reports", "content-create", "social-week", "approval"],
  managed: ["overview", "growth-score", "competitors", "nichecom", "insights", "reports", "content-create", "social-week", "approval", "managed"],
};

export function can(tier, cap) {
  return (CAPS[tier] || CAPS.score).includes(cap);
}
